<template>
    <div class="row subscriptions-tab">
        <div class="col-12 col-md-6 col-mxl-7">
            <section
                id="return-management-soon"
                v-if="isReturnable && subscriptionEndsInTwoMonths">
                <return-management :delivery-data="subscriptionData"></return-management>
            </section>

            <section id="subscription-condition-management">
                <subscription-condition-management
                    :subscription-data="subscriptionData"
                    :price-plan="subscriptionData.price_plan"
                    :additional-mileage-costs="subscriptionData.additional_mileage_costs"
                    :timestamps="subscriptionData.timestamps"
                    :has-subscription-end-date="hasSubscriptionEndDate"
                    class="mb-3"
                ></subscription-condition-management>
            </section>

            <section v-if="subscriptionData" id="vehicle-provider">
                <vehicle-provider-details
                    :provider-data="subscriptionData"
                    class="mb-3"
                ></vehicle-provider-details>
            </section>

            <section v-if="subscriptionData.type == 'MVS' && isActiveSubStatus" id="subscription-vehicle-switch">
                <subscription-vehicle-switch
                    :subscription-data="subscriptionData"
                    class="mb-3"
                ></subscription-vehicle-switch>
            </section>

            <section
                id="return-management"
                v-if="isReturnable && !subscriptionEndsInTwoMonths">
                <return-management :delivery-data="subscriptionData"></return-management>
            </section>
            <section
                id="delivery-management"
                v-else-if="!isReturnable">
                <delivery-management :delivery-data="subscriptionData"></delivery-management>
            </section>
        </div>
        <div class="col-12 col-md-6 col-xl-5">
            <section id="subscription-progress-timeline">
                <subscription-progress-timeline
                    :subscription-data="subscriptionData"
                    :has-subscription-end-date="hasSubscriptionEndDate"
                    :will-have-subscription-end-date="willHaveSubscriptionEndDate"
                ></subscription-progress-timeline>
            </section>
        </div>
    </div>
</template>

<script>
import SubscriptionProgressTimeline from "../molecules/SubscriptionProgressTimeline.vue";
import SubscriptionConditionManagement from "../molecules/SubscriptionConditionManagement.vue";
import SubscriptionVehicleSwitch from "../molecules/SubscriptionVehicleSwitch.vue";
import DeliveryManagement from "../molecules/DeliveryManagement.vue";
import ReturnManagement from "../molecules/ReturnManagement.vue";
import moment from "moment"
import VehicleProviderDetails from "../molecules/VehicleProviderDetails.vue";

export default {
    name: 'CdbTabSubscription',
    components: {
        VehicleProviderDetails,
        DeliveryManagement,
        ReturnManagement,
        SubscriptionConditionManagement,
        SubscriptionVehicleSwitch,
        SubscriptionProgressTimeline,
    },
    props: {
        subscriptionData: {
            type: Object,
            required: true
        }
    },
    computed: {
        hasSubscriptionEndDate() {
            const { status, timestamps } = this.subscriptionData
            if (timestamps.cancel_to !== null && (status === 'SUBSCRIPTION_FINISHED' || status === 'SUBSCRIPTION_CUSTOMER_CANCELLATION' || status === 'SUBSCRIPTION_HANDOVER_AGREED' || status === 'SUBSCRIPTION_ACTIVE')) {
                return true
            }
            return false
        },
        willHaveSubscriptionEndDate() {
            const { status } = this.subscriptionData
            return status === 'SUBSCRIPTION_ACTIVE'
        },
        isReturnable() {
            const { status } = this.subscriptionData
            return status === 'SUBSCRIPTION_CUSTOMER_CANCELLATION'
        },
        isActiveSubStatus() {
            const { status } = this.subscriptionData
            if (status === 'SUBSCRIPTION_ACTIVE' || status === 'SUBSCRIPTION_CUSTOMER_CANCELLATION' || status === 'SUBSCRIPTION_PARTNER_CANCELLATION') {
                return true
            }
            return false
        },
        subscriptionEndsInTwoMonths() {
            const { timestamps } = this.subscriptionData
            if(timestamps.cancel_to !== null) {
                const cancelToDate = moment.unix(timestamps.cancel_to)
                const monthlyDifference = cancelToDate.diff(moment(), 'months')
                return monthlyDifference <= 2
            } else {
                return false
            }
        }
    }
}
</script>
